import MangoXImage from "./MangoXImage/MangoXImage";
import { MonitoringDashboard } from "./Monitor/MonitoringDashboard";
export { MangoXImage, MonitoringDashboard };
